exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i.homeAboutLogo {\n  float: left;\n  width: 90px;\n  height: 90px;\n  display: block;\n  margin-right: 25px;\n  background: url(" + require("../../assets/img/eti-gumus-logo.svg") + ") center center no-repeat; }\n\nh1 {\n  color: red;\n  font-size: 28px;\n  color: #383E9A;\n  margin: 26px 0 50px; }\n\np {\n  color: #00032D;\n  font-size: 14px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/home/home.component.scss
// module id = ../../../../../src/app/home/home.component.scss
// module chunks = main